module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"14px\" height=\"12px\" viewBox=\"0 0 14 12\" enable-background=\"new 0 0 14 12\" xml:space=\"preserve\"><g><g><polygon fill=\"#FFFFFF\" points=\"6.5,9.3 1.5,10.2 1.5,1.8 6.5,2.7 6.5,4 8,4 8,1.5 0,0 0,12 8,10.5 8,8 6.5,8 \"></polygon></g><polygon fill=\"#FFFFFF\" points=\"10,9 14,6 10,3 10,5 10,5.2 3,5.2 3,6.8 10,6.8 10,7 \"></polygon></g></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/sign_out.svg
 ** module id = 1059
 ** module chunks = 0
 **/